angular
    .module("skillBuilderSaaS")
    .filter("sbReplaceSpaceWithDash", function () {
    return function (input) {
        return input.replace(/\s+/g, "-");
    };
});
